export enum ResetPasswordResponse {
  ERROR = 'error',
  OK = 'ok',
}

export interface ResetPasswordDto {
  response: ResetPasswordResponse;
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/ResetPasswordDto.ts